export default __webpack_public_path__ + "static/media/spark_82.776b84e8.png";